const BYPASS_KEY = 'a7ffc6f8bf1ed76651c14756a061d662f580ff4de43b49fa82d80a4b80f8434a';

const isSelenium = (document: any, window: Window) => {
  // if webDriver detection happens then short circuit
  const driverKey = document?.getElementById('modal-box')?.getAttribute('key') || '';
  if (window?.navigator?.webdriver && driverKey !== BYPASS_KEY) return true;

  // Check document cache of selenium
  const key = '$cdc_asdjflasutopfhvcZLmcfl_';
  return !!document[key];
};

const allValidators = [isSelenium];

export const checkHooman = () => {
  for (const fn of allValidators) {
    const result = fn(document, window);
    if (result) {
      // User is not human :)
      return false;
    }
  }
  return true;
};
